import { AnalyticsBrowser, Analytics } from "@segment/analytics-next";
import { env } from "./env";

// Initialize Segment Analytics
let analytics: Analytics | null = null;

export const initAnalytics = async () => {
  const writeKey = env.SEGMENT_ANALYTICS_KEY;

  if (!writeKey) {
    // Silently skip analytics initialization if no key is provided
    return null;
  }

  if (analytics) {
    return analytics;
  }

  try {
    const [response] = await AnalyticsBrowser.load({
      writeKey,
    });

    analytics = response;
    return analytics;
  } catch (error) {
    // Silently fail if analytics fails to load
    console.error('Failed to initialize Segment Analytics:', error);
    return null;
  }
};

// Track page views (matches Ember's trackPage)
export const trackPage = (page: string, title: string) => {
  if (!analytics) {
    return;
  }

  analytics.page(undefined, page, { page, title });
};

// Track events (matches Ember's trackEvent)
const trackEvent = (event: string, properties?: Record<string, unknown>) => {
  if (!analytics) {
    return;
  }

  analytics.track(event, properties);
};

// Track "Tagged Response" event (matches Ember exactly)
export const trackTaggedResponse = (organization: string, responseId: string) => {
  trackEvent("Tagged Response", {
    organization,
    responseId,
  });
};
